import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';

var getMediaQueryList = function getMediaQueryList(query) {
  return window.matchMedia(query);
};

export var useMediaQuery = function useMediaQuery(query) {
  var initialMql = getMediaQueryList(query);

  var _useState = useState(initialMql),
      _useState2 = _slicedToArray(_useState, 2),
      mql = _useState2[0],
      setMql = _useState2[1];

  var _useState3 = useState(initialMql),
      _useState4 = _slicedToArray(_useState3, 2),
      values = _useState4[0],
      setValues = _useState4[1];

  useEffect(function () {
    setMql(getMediaQueryList(query));
  }, [query]);
  useEffect(function () {
    mql.addEventListener('change', setValues);
    return function () {
      mql.removeEventListener('change', setValues);
    };
  }, [mql]);
  var matches = values.matches,
      media = values.media;
  return {
    matches: matches,
    media: media
  };
};